function mapDim(dimension) {
    switch (dimension) {
      case "20 pieds 33m3 à 350€":
        return "33m3";
      case "8m3 à 96€":
        return "8m3";
      case "12m3 à 144€":
        return "12m3";
      case "16m3 à 198€":
        return "16m3";
      case "40 pieds 76m3 à 550€":
        return "76m3";
      case "J'ai besoin de moins":
        return "moins";
      case "J'ai un besoin spécifique":
        return "spécifique";
      case "12m3":
        return "12m3";
      case "16m3":
        return "16m3";
      case "8m3":
        return "8m3";

      case "20 pieds 33m3":
        return "33m3";
      case "40 pieds 76m3":
        return "76m3";

      case "Container 20 pieds 33m3":
        return "33m3";
      case "Box 12m3":
        return "12m3";

      case "Box 8m3":
        return "8m3";

      case "Box 16m3":
        return "16m3";

      default:
        return dimension;
    }
  }
export default mapDim;